import script from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBar.vue?vue&type=style&index=0&id=1fbb8e8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbb8e8a"]])

export default __exports__